module.exports = __webpack_public_path__ + "static/media/equalicare-img01b.629bb226.png";